import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { LOCALE_ID, isDevMode, provideZonelessChangeDetection, provideAppInitializer, inject } from '@angular/core';
import { provideTaiga } from '@taiga-ui/core';
import { provideTransloco } from '@jsverse/transloco';
import { provideTranslocoMessageformat } from '@jsverse/transloco-messageformat';
import { AbstractSecurityStorage, authInterceptor, provideAuth, withAppInitializerAuthCheck } from 'angular-auth-oidc-client';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { TranslocoHttpLoader } from './app/transloco-loader';
import { openIdConfiguration } from './app/shared/auth/openid-configuration';
import { OpenIdLocalStorage } from './app/shared/auth/openid-storage';
import { AuthRecoveryService } from './app/shared/services/auth-recovery.service';

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),
        provideRouter(routes),
        provideAnimations(),
        provideHttpClient(withInterceptors([authInterceptor()])),
        provideTaiga({ mode: 'light' }),
        provideTransloco({
            config: {
                availableLangs: ['en', 'ru'],
                defaultLang: 'ru',
                reRenderOnLangChange: true,
                prodMode: !isDevMode()
            },
            loader: TranslocoHttpLoader
        }),
        provideTranslocoMessageformat(),
        { provide: LOCALE_ID, useValue: 'ru-RUS' },
        provideAuth({ config: openIdConfiguration }, withAppInitializerAuthCheck()),
        { provide: AbstractSecurityStorage, useClass: OpenIdLocalStorage },
        provideAppInitializer(() => inject(AuthRecoveryService).initialize()),
    ]
}).catch(err => console.error(err));
